import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import { mtOrderOpenUrl, mtOrderHistoryUrl, mtPortfolioListUrl } from './_endpoint';
import { stockAutoOrderListUrl } from '../_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

// MT Portfolio
export const getMtPortfolioList = () => fetchGet(mtPortfolioListUrl);

// MT Order history list
export const getMtOrderOpen = (query = {}) => fetchGet(mtOrderOpenUrl, { query });
export const getMtOrderHistory = (query = {}) => fetchGet(mtOrderHistoryUrl, { query });
export const getMtAutoOrderList = (query = {}) =>
  fetchGet(stockAutoOrderListUrl, { query: { ...query, account_type: 'MARGIN' } });
